import { c as _c } from "react/compiler-runtime";
import { ProductCard } from '@petsmart-ui/sparky';
import { MiniPdpCTA } from '../../MiniPdpDrawer';
interface ProductCardWithVariationsProps {
  __position: number;
  sku: string;
  title?: string;
  description?: string;
  href?: string;
  target?: '_self' | '_blank';
  imgSrc?: string;
  imgAlt?: string;
  brand?: string;
  priceVariant?: 'primary' | 'disabled' | 'sale';
  prices?: (string | number)[];
  isPriceRange?: boolean;
  outOfStock?: boolean;
  rating?: number;
  ratingLabel?: string;
  variations?: string;
  showQuickAdd?: boolean;
}
export function ProductCardWithVariations(t0) {
  const $ = _c(15);
  let productProps;
  let showQuickAdd;
  let variations;
  if ($[0] !== t0) {
    ({
      variations,
      showQuickAdd,
      ...productProps
    } = t0);
    $[0] = t0;
    $[1] = productProps;
    $[2] = showQuickAdd;
    $[3] = variations;
  } else {
    productProps = $[1];
    showQuickAdd = $[2];
    variations = $[3];
  }
  let t1;
  if ($[4] !== productProps) {
    t1 = <ProductCard {...productProps} />;
    $[4] = productProps;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== variations) {
    t2 = variations && <div className="product-card-with-variations__text">{variations}</div>;
    $[6] = variations;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== productProps || $[9] !== showQuickAdd) {
    t3 = showQuickAdd && <MiniPdpCTA productId={productProps.sku} />;
    $[8] = productProps;
    $[9] = showQuickAdd;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t1 || $[12] !== t2 || $[13] !== t3) {
    t4 = <div className="product-card-with-variations">{t1}{t2}{t3}</div>;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
}